import { Carousel, Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

export default function VibrantWorkplace(){
    const { t } = useTranslation();

    return(
        <article id="vibrantworkplace">
            <section className="vibrant-workplace">
                <Container>
                    <Row>
                        <Col>
                            <div class="section-highlight">{t(`lifeatcentrico.vibrantworkplace.title`)}</div>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md={12}>
                            <Carousel interval={3000}>
                                <Carousel.Item>
                                    <div className="events-wrapper">
                                        <Row>
                                            <Col md={6} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/event1.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">Gen AI Hackathon 2025</div>
                                                        <div className="event-description">Collaborative event to turn ideas into working solutions</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/event2.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">Out Bound Training</div>
                                                        <div className="event-description">Experiential learning programs through the year</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <div className="events-wrapper">
                                        <Row>
                                            <Col md={6} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/event3.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">Annual Townhall</div>
                                                        <div className="event-description">Discussion of best practices, strategic roadmaps & talks led by industry experts</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/event4.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">Sports Events</div>
                                                        <div className="event-description">Sportsmanship runs in our DNA</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <div className="events-wrapper">
                                        <Row>
                                            <Col md={6} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/event5.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">International Women's Day</div>
                                                        <div className="event-description">Guest talks and artistic expression of Women's rights</div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={6} className="mb-2">
                                                <div className="events-container">
                                                    <div className="event-image">
                                                        <LazyLoadImage src={require("../../images/event6.jpg")} />
                                                    </div>
                                                    <div className="event-info">
                                                        <div className="event-title">International Men's Day</div>
                                                        <div className="event-description">Appreciating and celebrating Men’s Day</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                </Container>
            </section>
        </article>
    )
}